import { ArcRotateCamera, FramingBehavior, Mesh, Vector2, Animation, Engine} from "@babylonjs/core";
import { Node } from "@babylonjs/core/node";
import { visibleInInspector,onKeyboardEvent,fromScene,onPointerEvent } from "./decorators";

/**
 * This represents a script that is attached to a node in the editor.
 * Available nodes are:
 *      - Meshes
 *      - Lights
 *      - Cameas
 *      - Transform nodes
 * 
 * You can extend the desired class according to the node type.
 * Example:
 *      export default class MyMesh extends Mesh {
 *          public onUpdate(): void {
 *              this.rotation.y += 0.04;
 *          }
 *      }
 * The function "onInitialize" is called immediately after the constructor is called.
 * The functions "onStart" and "onUpdate" are called automatically.
 */
export default class WVCamera extends ArcRotateCamera {
    @visibleInInspector("number","最大俯仰角")
    private _upperBetaLimit:number = 80;
    @visibleInInspector("number","最小俯仰角")
    private _lowerBetaLimit:number = 5;
    @visibleInInspector("number","最远距离")
    private _upperRadiusLimit:number = 50;
    @visibleInInspector("number","最近距离")
    private _lowerRadiusLimit:number = 1;
    @visibleInInspector("number","最大平移距离")
    private _paddingDistanceLimit:number = 100;

    private _targetMesh:Mesh;
    public _focusToRadio:number = null;

    /**
     * Override constructor.
     * @warn do not fill.
     */
    // @ts-ignore ignoring the super call as we don't want to re-init
    protected constructor() { }

    /**
     * Called on the node is being initialized.
     * This function is called immediatly after the constructor has been called.
     */
    public onInitialize(): void {

    }

    /**
     * Called on the scene starts.
     */
    public onStart(): void {
        var scene = this.getScene();
        // ...
        //相机限位
        this.upperBetaLimit = Math.PI * (this._upperBetaLimit / 180);
        this.lowerBetaLimit = Math.PI * (this._lowerBetaLimit / 180);
        this.upperRadiusLimit = this._upperRadiusLimit;
        this.lowerRadiusLimit = this._lowerRadiusLimit;

        //最大平移距离
        this.panningDistanceLimit = this._paddingDistanceLimit;

        




        let self = this;
        //如果点到物体
        // scene.onPointerPick=function(){
        //     var pickResult = scene.pick(scene.pointerX, scene.pointerY);
    
        //     if (pickResult.hit) {
        //         if(pickResult.pickedMesh.name.substring(0,6) == "Ground"){
        //             console.log("点击了：",pickResult.pickedMesh.name,pickResult.pickedPoint);
        //             self.setTarget(pickResult.pickedPoint);
        //         }
        //         // var diffX = pickResult.pickedPoint.x - box.position.x;
        //         // var diffY = pickResult.pickedPoint.z - box.position.z;
        //         // box.rotation.y = Math.atan2(diffX,diffY);			          
        //     }	
        // }
        //this.lockedTarget = this._targetMesh;
        // this.targetScreenOffset = new Vector2(0,-0.3);
        // this.inertialBetaOffset = 1;
        // this.inertialAlphaOffset = 1;
        // this.inertialRadiusOffset = 1;
        this.useFramingBehavior = true;//自动寻的
        this.framingBehavior.mode = FramingBehavior.FitFrustumSidesMode;
        this.framingBehavior.radiusScale = 5;

        // this._targetMesh = scene.getMeshByName("MoeTarget") as Mesh;
        // this.setTarget(this._targetMesh);
    }

    /**
     * Called each frame.
     */
    public onUpdate(deTime:number): void {
        // ...
        let deltaTime:number = this.getEngine().getDeltaTime() * 0.001;
        if(this._focusToRadio){
            console.log(this.radius,this._focusToRadio,deTime,deltaTime);
            let d = Math.abs(this._focusToRadio - this.radius);
            if(d < 0.01 ){
                this._focusToRadio = null;
            }else{
                this.radius += (this._focusToRadio - this.radius) * deltaTime * 2;
            }
            // }else if(this._focusToRadio < this.radius){
            //     this.radius -=  0.8;
            // }else{
            //     this.radius +=  0.8;
            // }
            
        }
    }

    /**
     * Called on the object has been disposed.
     * Object can be disposed manually or when the editor stops running the scene.
     */
    public onStop(): void {
        // ...
    }

    /**
     * Called on a message has been received and sent from a graph.
     * @param message defines the name of the message sent from the graph.
     * @param data defines the data sent in the message.
     * @param sender defines the reference to the graph class that sent the message.
     */
    public onMessage(name: string, data: any, sender: any): void {
        switch (name) {
            case "myMessage":
                // Do something...
                break;
        }
    }
}
